import { Location } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../core/services/auth.service";

@Component({
  selector: "app-not-found",
  standalone: true,
  imports: [],
  templateUrl: "./not-found.component.html",
  styleUrl: "./not-found.component.scss",
})
export class NotFoundComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  readonly attemptedUrl = this.router.url;

  goBack(): void {
    if (typeof window !== "undefined" && window.history.length > 1) {
      this.location.back();
      return;
    }
    const home = this.auth.getHomeUrlForCurrentUser() || "/welcome";
    void this.router.navigateByUrl(home);
  }
}
